const esPlural = new Intl.PluralRules('es');

/**
 * Pluraliza una palabra basado en el conteo usando las reglas de pluralización en español
 * @param count - Number to evaluate
 * @param singular - Singular form of the word
 * @param plural - Plural form of the word
 * @returns Palabra en singular o plural según el conteo
 * @example
 * pluralize(1, 'contacto', 'contactos') // 'contacto'
 * pluralize(0, 'contacto', 'contactos') // 'contactos'
 * pluralize(5, 'tarjeta', 'tarjetas') // 'tarjetas'
 */
export function pluralize(count: number, singular: string, plural: string): string {
  return esPlural.select(count) === 'one' ? singular : plural;
}
